import { Component, OnInit, Input, ViewChild, Output, EventEmitter, Type } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { ClassesService } from '../services/classes.service';
import { ReactiveInputComponent } from 'app/shared/components/reactive-input/reactive-input.component';
import { RxComponent } from 'app/core/components/common/rx.component';
import { SmartModalService, ModalSize } from 'app/core/services/smart-modal.service';
import { AddInstructorComponent } from '../add-instructor/add-instructor.component';
import { InstructorSelectEvent, InstructorsLoadEvent } from 'app/solar/classes/components/wizard/class-instructor/class-instructor.component';
import { EditInstructorComponent } from 'app/solar/classes/components/wizard/class-instructor/edit-instructor/edit-instructor.component';
import { NotificationService } from 'app/core/services/notification.service';

declare var moment: any;

@Component({
  selector: 'itpx-exam-in-session-info',
  templateUrl: './exam-in-session-info.component.html',
  styleUrls: ['./exam-in-session-info.component.css']
})


export class ExamInSessionInfoComponent extends RxComponent {

  @Input() private exam: any;
  @Input() private status: string;
  @Input() private class: any;
  @Input() private maxTurnaroundTime: Observable<number>;
  @Output() private formStateChange = new EventEmitter<any>();
  private turnaroundTime: number;
  private examMinDate: Date;
  private examInfo: FormGroup;
  private productGroups: any[];
  private addClick = new Subject<string>();
  private editClick = new Subject<string>();
  private instructorSelect = new Subject<InstructorSelectEvent>();
  private instructorsPerGroups: Observable<any>;
  // private timezones: Observable<any[]>;

  @ViewChild('examDate') examDateElement: ReactiveInputComponent;
  @ViewChild('examTime') examTimeElement: ReactiveInputComponent;

  constructor(private fb: FormBuilder,
    private classesService: ClassesService,
    private modalService: SmartModalService,
    private notificationService: NotificationService, ) { super(); }

  ngOnInit() {

    this.examInfo = this.fb.group({
      id: [this.status === 'edit' ? this.exam.id : this.exam.productId],
      examDate: [{ value: this.exam.date, disabled: !this.getPolicy('exam', 'date_time', 'required') },
      this.getPolicy('exam', 'date_time', 'mandatory') ? [Validators.required] : []],
      examTime: [{ value: this.status === 'edit' ? moment(this.exam.date).format('HH:mm') : null, disabled: !this.getPolicy('exam', 'date_time', 'required') },
      this.getPolicy('exam', 'date_time', 'mandatory') ? [Validators.required] : []],

      // one or all of the info below can also be editable for each exam, but i don't think all of them are needed

      // proctorId: [{ value: this.exam.proctorId ? this.exam.proctorId : null, disabled: !this.getPolicy('proctor', 'email_phone', 'required') },
      // this.getPolicy('proctor', 'email_phone', 'mandatory') ? [Validators.required] : []],
      // personId: [{ value: this.exam.contactPerson ? this.exam.contactPerson : null, disabled: !this.getPolicy('contact', 'email_phone', 'required') },
      // this.getPolicy('contact', 'email_phone', 'mandatory') ? [Validators.required] : []],
      // venueId: [{ value: this.exam.address ? this.exam.address : null, disabled: !this.getPolicy('exam', 'venue', 'required') },
      // this.getPolicy('exam', 'venue', 'mandatory') ? [Validators.required] : []],
      // timezone: [{ value: this.exam.timezone ? this.exam.timezone : moment.tz.guess(), disabled: !this.getPolicy('exam', 'date_time', 'required') },
      // this.getPolicy('exam', 'date_time', 'mandatory') ? [Validators.required] : []],
      // additionalInfo: [{ value: this.exam.additionalInfo ? this.exam.additionalInfo : null }]
    });
    this.productGroups = this.status === 'create' ? [this.exam.agoraProductVariant.product.group] : [this.exam.productVariant.product.group];
    this.examInfo.statusChanges
      .bindToLifecycle(this)
      .subscribe(status => {
        this.formStateChange.emit({ valid: status == 'VALID', dirty: {}, data: this.getFormData() });
      });
    switch (this.status) {
      case 'create':
        this.maxTurnaroundTime
          .bindToLifecycle(this)
          .subscribe(turnaround => {
            // let turnAroundTimeDays = turnaround / 24;
            this.turnaroundTime = turnaround || 72;
            this.examMinDate = moment().startOf('day').add(this.turnaroundTime / 24, 'days')._d;
            let examTimeStr = moment().set({ h: 12, m: 0 }).format('HH:mm');
            this.examInfo.controls.examTime.setValue(examTimeStr);
            this.examInfo.controls.examDate.setValue(this.examMinDate);
            this.examDateElement.set('minDate', this.examMinDate);
          });
        break;
      case 'edit':
        this.maxTurnaroundTime
          .bindToLifecycle(this)
          .subscribe(turnaround => {
            // let turnAroundTimeDays = turnaround / 24;
            this.turnaroundTime = turnaround;
            this.examMinDate = moment(this.exam.classEvent.releaseDate).startOf('day').add(this.turnaroundTime / 24, 'days')._d;
            this.examDateElement.set('minDate', this.examMinDate);
            // let examTimeStr = moment(this.exam.date).format('HH:mm');
            // this.examInfo.controls.examTime.setValue(examTimeStr);
          });
        break;
    }


    // this.timezones = this.classesService.getTimezonesDictionary()
    //   .map(body => body.data)
    //   .neverError();

    let instructorAdded = this.addClick
      .flatMap(groupId => this.modalService.open(<Type<Component>>AddInstructorComponent, null, 'Add New Instructor')
        .map(res => new InstructorSelectEvent(groupId, res.result, false))
        .neverError()
      )
      .shareReplay();
    let instructorEdited = this.editClick
      .flatMap(groupId => this.modalService.open(<Type<Component>>EditInstructorComponent,
        { id: this.class ? this.class.id : null, groupId: groupId }, 'Manage Instructors', ModalSize.Lg)
        .catchAndEmit(new InstructorsLoadEvent(groupId, null)))
      .shareReplay();
    instructorAdded
      .bindToLifecycle(this)
      .subscribe(instructor => {
        this.examInfo.controls.instructorId.setValue(instructor.instructorId);
        this.notificationService.success('Class instructor added.');
      });

    // console.log(this.examsInSession.map(e => e.product.group.id));
    let instructorsLoaded = Observable.merge(instructorAdded, instructorEdited, Observable.of(true))
      // Emit every product group
      // .flatMap(_ => Observable.from(this.status === 'create' ? this.exam.agoraProductVariant.product.group.id : this.exam.productVariant.product.group.id))
      // Fetch instructor lists
      .flatMap(_ => this.classesService.getAccreditedInstructors(this.productGroups[0].id))
      .map(body => new InstructorsLoadEvent(this.productGroups[0].id, body.data))
      .catchAndEmit(new InstructorsLoadEvent(this.productGroups[0].id, null))

      .share();
    let instructorSelected = Observable.merge(this.instructorSelect, instructorAdded.takeWhen(instructorsLoaded))
      .shareReplay();

    this.instructorsPerGroups = Observable.merge(instructorsLoaded, instructorSelected)
      .scan((total, event) => {
        if (event instanceof InstructorsLoadEvent) {
          let savedInstructor = null;
          let classInstructor = null;
          let isVirtual = false;
          if (this.class && this.class.instructors[event.groupId]) {
            classInstructor = this.class.instructors[event.groupId].instructor;
            isVirtual = this.class.instructors[event.groupId].virtual;
          }

          if (classInstructor) {
            savedInstructor = { key: classInstructor.id, value: classInstructor.username };
          }
          let current = total[event.groupId] ? total[event.groupId].current : savedInstructor;
          if (current && event.instructors.filter(entry => entry.key == current.key).length == 0) {
            current = null;
          }
          total[event.groupId] = {
            current: current,
            virtual: isVirtual,
            all: event.instructors
          };
        } else if (event instanceof InstructorSelectEvent) {
          total[event.groupId].virtual = event.virtual;
          if (event.instructorId) {
            total[event.groupId].current = total[event.groupId].all.find(i => i.key == event.instructorId);
          }
        }
        return total;
      }, {})
      .startWith({})
      .shareReplay();

    this.instructorSelect.subscribe(
      event => {
        this.examInfo.controls.instructorId.setValue(event.instructorId);
        this.examInfo.markAsDirty();
      }
    )

  }

  private getPolicy(key: string, key2: string, key3: string) {
    if (this.status === 'create') {
      if (this.exam.agoraProductVariant.policies && this.exam.agoraProductVariant.policies.hasOwnProperty(key) && this.exam.agoraProductVariant.policies[key].hasOwnProperty(key2) && this.exam.agoraProductVariant.policies[key][key2].hasOwnProperty(key3))
        return this.exam.agoraProductVariant.policies[key][key2][key3];
    }
    else {
      if (this.exam.productVariant.policies && this.exam.productVariant.policies.hasOwnProperty(key) && this.exam.productVariant.policies[key].hasOwnProperty(key2) && this.exam.productVariant.policies[key][key2].hasOwnProperty(key3))
        return this.exam.productVariant.policies[key][key2][key3];
    }
    return true;
  }

  private getFormData(): any {
    let formData = this.examInfo.getRawValue();
    formData.examDate = moment(formData.examDate).startOf('day')._d;
    let [hours, minutes] = formData.examTime && formData.examTime != '' ?
      formData.examTime.split(':') :
      moment(formData.examDate).format('HH:mm').split(':');

    formData.examDate = this.toLocalTime(formData.examDate, parseInt(hours, 10), parseInt(minutes, 10));
    formData.examMinDate = this.examMinDate;
    return formData;
  }

  private toLocalTime(date: any, hours?: number, minutes?: number): string {
    let mDate = moment(date);
    if (hours >= 0 && minutes >= 0) {
      mDate.set({ hour: hours, minute: minutes });
    }

    return moment(mDate).utc().add(mDate.utcOffset(), 'm').format();
  }

  private onInstructorAddClick(groupId: string) {
    this.addClick.next(groupId);
  }

  private onInstructorEditClick(groupId: string) {
    this.editClick.next(groupId);
  }

  private onInstructorSelect(groupId: string, instructorId: any) {
    this.instructorSelect.next(new InstructorSelectEvent(groupId, instructorId, false));
  }

}



// WEBPACK FOOTER //
// ./src/app/solar/common/exam-in-session-info/exam-in-session-info.component.ts